// Per-layer override → inline style. Reads story._ov[layerId] =
// {hidden,dx,dy,scale,sx,sy,opacity,color,fillImage}.
export const ovStyle = (ov, id) => {
    const o = (ov && ov[id]) || {};
    if (o.hidden) return { display: "none" };
    const parts = [];
    if (o.dx || o.dy) parts.push(`translate(${o.dx || 0}px,${o.dy || 0}px)`);
    if (o.rot) parts.push(`rotate(${o.rot}deg)`);
    if (o.scale && o.scale !== 1) parts.push(`scale(${o.scale})`);
    if ((o.sx && o.sx !== 1) || (o.sy && o.sy !== 1)) parts.push(`scale(${o.sx || 1},${o.sy || 1})`);
    const style = {};
    if (parts.length) { style.transform = parts.join(" "); style.transformOrigin = "left center"; }
    if (o.opacity != null) style.opacity = o.opacity;
    // Image-fill mask: paints an image THROUGH the layer's text (real mask, not faked).
    if (o.fillImage) {
        style.backgroundImage = `url(${o.fillImage})`;
        style.backgroundSize = "cover";
        style.backgroundPosition = "center";
        style.WebkitBackgroundClip = "text";
        style.backgroundClip = "text";
        style.WebkitTextFillColor = "transparent";
        style.color = "transparent";
    } else if (o.color) {
        style.color = o.color;
    }
    return style;
};

// Layers exposed in the editor, per template layout/style.
// Each entry: [id, label, type, field]
//   type:  "text" | "list" | "player" | "team" | "image"
//   field: story key the layer's text maps to ("__name" = subject.name)
export const LAYER_SPEC = {
    contract: [
        ["kicker", "Kicker", "text", "kicker"],
        ["headline", "Headline", "text", "bannerWord"],
        ["photo", "Player", "player", "__name"],
        ["name", "Name", "text", "__name"],
        ["terms", "Terms", "list", "terms"],
        ["footer", "Footer", "text", "source"],
    ],
};

export const layersFor = (tpl) => {
    if (!tpl) return [];
    if (tpl.layout === "contract") return LAYER_SPEC.contract;
    return [];
};
